import Tr from 'translations/Translations';

export const RoundType = {
	BASE: "BASE",
	ADDITIONAL_OFFERS: "ADDITIONAL_OFFERS",
	AUCTION: "AUCTION"
}

const _TR_PREFIX = 'additional_round_type_';

export const RoundTypeLabel = (status) => (Tr(_TR_PREFIX + status.toLowerCase()));
